import { HIDE_SAVING_MODAL } from "store/experiences/actionTypes"
import {
  GET_MENU_ICONS_SUCCESS,
  HIDE_DELETE_FEATURE_MODAL,
  HIDE_SELECT_ICON_MODAL,
  OPEN_DELETE_FEATURE_MODAL,
  OPEN_SELECT_ICON_MODAL,
  SET_ISOUTDATED,
  SET_SELECTED_FEATURE,
  SHOW_SAVING_MODAL,
  ADD_MENU_FEATURE_SUCCESS,
  GET_FEATURE_DEEPLINK_URL_SUCCESS,
  GET_FEATURE_DEEPLINK_CODES,
  GET_FEATURE_DEEPLINK_CODES_SUCCESS,
  GET_FEATURE_DEEPLINK_CODES_FAILED,
  GET_FEATURE_DEEPLINK_URL,
  OPEN_GENERATE_FEATURE_DEEPLINK_MODAL,
  HIDE_GENERATE_FEATURE_DEEPLINK_MODAL,
  DISPLAY_LOCK_WARNING_MODAL,
  HIDE_LOCK_WARNING_MODAL,
  CLONE_MENU_FEATURE_SUCCESS,
  CLONE_MENU_FEATURE,
  CLONE_MENU_FEATURE_FAILED,
  SET_MENU_FEATURE_UPDATE_LOADING,
  DELETE_MENU_ITEM,
  DELETE_MENU_ITEM_FAILED,
  DELETE_MENU_ITEM_SUCCESS,
  HIDE_FEATURE_NOTIFICATION_MODAL,
  OPEN_FEATURE_NOTIFICATION_MODAL,
  EDIT_MENU_ITEM_FAILED,
  EDIT_MENU_ITEM_SUCCESS,
} from "./actionTypes"

const INIT_STATE = {
  showSavingModal: false,
  selectedFeature: null,
  menuIcons: [],
  isSelectIconModalOpen: false,
  isDeleteFeatureModalOpen: false,
  isOutdated: false,
  featureDeepLinkUrl: null,
  featureDeeplinkCodes: null,
  featureDeeplinkCodesAreLoading: false,
  generateFeatureDeeplinkModalIsOpen: false,
  lockWarningModalIsOpen: false,
  loading: false,
  updateIsLoading: false,
  deleteIsLoading: false,
  featureNotificationModalIsOpen: false,
}

const MenuFeatures = (state = INIT_STATE, action) => {
  switch (action.type) {
    case ADD_MENU_FEATURE_SUCCESS:
      return {
        ...state,
        selectedFeature: action.payload,
      }
    case GET_MENU_ICONS_SUCCESS:
      return {
        ...state,
        menuIcons: action.payload,
      }
    case OPEN_SELECT_ICON_MODAL:
      return {
        ...state,
        isSelectIconModalOpen: true,
      }
    case HIDE_SELECT_ICON_MODAL:
      return {
        ...state,
        isSelectIconModalOpen: false,
      }
    case OPEN_DELETE_FEATURE_MODAL:
      return {
        ...state,
        isDeleteFeatureModalOpen: true,
      }
    case HIDE_DELETE_FEATURE_MODAL:
      return {
        ...state,
        isDeleteFeatureModalOpen: false,
      }
    case SHOW_SAVING_MODAL:
      return {
        ...state,
        showSavingModal: true,
      }
    case HIDE_SAVING_MODAL:
      return {
        ...state,
        showSavingModal: false,
      }
    case SET_ISOUTDATED:
      return {
        ...state,
        isOutdated: action.payload,
      }
    case SET_SELECTED_FEATURE:
      return {
        ...state,
        selectedFeature: action.payload,
      }
    case GET_FEATURE_DEEPLINK_URL:
      return {
        ...state,
        featureDeepLinkUrl: null,
      }
    case GET_FEATURE_DEEPLINK_URL_SUCCESS:
      return {
        ...state,
        featureDeepLinkUrl: action.payload,
      }
    case GET_FEATURE_DEEPLINK_CODES:
      return {
        ...state,
        featureDeeplinkCodes: null,
        featureDeeplinkCodesAreLoading: true,
      }
    case GET_FEATURE_DEEPLINK_CODES_SUCCESS:
      return {
        ...state,
        featureDeeplinkCodes: action.payload,
        featureDeeplinkCodesAreLoading: false,
      }
    case GET_FEATURE_DEEPLINK_CODES_FAILED:
      return {
        ...state,
        featureDeeplinkCodesAreLoading: false,
      }
    case OPEN_GENERATE_FEATURE_DEEPLINK_MODAL:
      return {
        ...state,
        generateFeatureDeeplinkModalIsOpen: true,
      }
    case HIDE_GENERATE_FEATURE_DEEPLINK_MODAL:
      return {
        ...state,
        generateFeatureDeeplinkModalIsOpen: false,
      }
    case DISPLAY_LOCK_WARNING_MODAL:
      return {
        ...state,
        lockWarningModalIsOpen: true,
      }
    case HIDE_LOCK_WARNING_MODAL:
      return {
        ...state,
        lockWarningModalIsOpen: false,
      }
    case CLONE_MENU_FEATURE_SUCCESS:
      return {
        ...state,
        // selectedFeature: action.payload,
        lockWarningModalIsOpen: false,
        loading: false,
      }
    case CLONE_MENU_FEATURE:
      return {
        ...state,
        loading: true,
      }
    case CLONE_MENU_FEATURE_FAILED:
      return {
        ...state,
        loading: false,
        lockWarningModalIsOpen: false,
      }
    case SET_MENU_FEATURE_UPDATE_LOADING:
      return {
        ...state,
        updateIsLoading: action.payload,
      }
    case DELETE_MENU_ITEM:
      return {
        ...state,
        deleteIsLoading: true,
      }
    case DELETE_MENU_ITEM_FAILED:
    case DELETE_MENU_ITEM_SUCCESS:
      return {
        ...state,
        deleteIsLoading: false,
      }
    case OPEN_FEATURE_NOTIFICATION_MODAL:
      return {
        ...state,
        featureNotificationModalIsOpen: true,
      }
    case HIDE_FEATURE_NOTIFICATION_MODAL:
      return {
        ...state,
        featureNotificationModalIsOpen: false,
      }
    case EDIT_MENU_ITEM_FAILED:
    case EDIT_MENU_ITEM_SUCCESS:
      return {
        ...state,
        featureNotificationModalIsOpen: false,
      }
    default:
      return state
  }
}

export default MenuFeatures
